/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ACHTypeEnum {
    CHECKING = 'Checking',
    SAVINGS = 'Savings',
}